import { schema } from "normalizr";
export const referrer = new schema.Entity("referrer");
export const referrersSchema = new schema.Entity("referrers", {
  referrers: [referrer]
});
export const customField = new schema.Entity("customField");
export const customFieldsSchema = new schema.Entity("customFields", {
  customField: [customField]
});